import CrudBase from '../../../CrudBase';

const cancelamento = new CrudBase('api/comercial/pedidos-motivos-cancelamento');

export default cancelamento.defaultMethods;

